module.exports = __webpack_public_path__ + "static/media/dd_logo_v_rgb.936d3bbe.svg";